const localizers = {
  'loading.msg': () => `Načítava sa...`,
  'SASServer.genericError.msg': () => `Nedá sa spojiť so serverom.`,
  'SASReport.genericError.msg': () => `Nedá sa načítať vybratý report.`,
  'SASReportImage.genericError.msg': () => `Nepodarilo sa načítať obrázok reportu.`,
  'SASReportImage.imageNotSupported.msg': () => `Pre tento typ obsahu reportu nie sú obrázky podporované.`,
}
export default localizers;
